<template>
    <div>
      <!--修改升级记录-->
      <el-dialog :visible.sync="updateUpdateRecordDialogVisible" title="修改升级记录" @close="feedBack" v-if="updateUpdateRecordDialogVisible">
        <el-form label-width="100px" :model="AltUpdateRecord.params" :ref="AltUpdateRecord.params" :rules="rulesOfAltUpdateRecord">
          <!--<el-form-item label="警报点编号">-->
            <!--<el-input ></el-input>-->
          <!--</el-form-item>-->
          <!--<el-form-item label="地理区划">-->
            <!--<el-input></el-input>-->
          <!--</el-form-item>-->
          <el-form-item label="升级时间" prop="updateTime">
            <el-date-picker type="datetime" v-model="AltUpdateRecord.params.updateTime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <!--<el-form-item label="升级人">-->
            <!--<el-input ></el-input>-->
          <!--</el-form-item>-->
          <el-form-item label="升级内容" prop="updateContent">
            <el-input type="textarea" :rows="2" v-model="AltUpdateRecord.params.updateContent"></el-input>
          </el-form-item>
          <!--<el-form-item label="警报点编号">-->
            <!--<el-input type="textarea" :rows="2"></el-input>-->
          <!--</el-form-item>-->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="feedBack">取 消</el-button>
          <el-button type="primary" @click="altUpdateRecord">确定修改</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
  export default {
    name: 'UpdateUpdateRecord',
    props: ['updateUpdateRecordDialogVisible', 'AltUpdateRecord'],
    data(){
      return {
        rulesOfAltUpdateRecord:{
          updateTime:[{required: true, message:'升级时间不能为空', trigger: 'change'}],
          updateContent:[{required: true, message:'升级内容不能为空', trigger: 'change'}],
        }
      }
    },
    methods: {
      altUpdateRecord(){
        this.AltUpdateRecord.token = this.$store.state.token;
        console.log('修改升级记录请求');
        console.log(this.AltUpdateRecord);
        this.$axios.post(this.$mainUrl, this.AltUpdateRecord).then(res=>{
          console.log('修改升级记录请求得到响应');
          console.log(res.data);
          if(res.data.hasOwnProperty('result')){
            this.$message({
              type:'success',
              message: '修改升级记录成功'
            })
            this.feedBack()
          }else{
            this.$message({
              type: 'error',
              message: '修改升级记录失败，' + res.data.error.message
            })
          }
        })
      },
      feedBack(){
        console.log('返回');
        this.updateUpdateRecordDialogVisible = false;
        this.$emit('feedBack',this.updateUpdateRecordDialogVisible);
      }
    }
  }
</script>

<style scoped>

</style>
